var validator = function validator(data) {
  return {
    // 邮箱校验
    email: function email(rule, value, callback) {
      var regexp = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/; // let regexp = /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/; // 20210816 验证条件变更 还原  -  黄丽宏
      // let regexp = /^\w+@[a-zA-Z0-9]+(?:\.[a-z]{2,4}){1,3}$/; // 20210817 验证条件变更 还原  -  黄丽宏
      // let regexp = /^(.+)@(.+)$/;
      // let regexp = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;

      if (value) {
        if (value.match(regexp)) {
          callback();
        } else {
          callback(new Error('请输入正确格式的邮箱'));
        }
      } else {
        callback();
      }
    },
    // 手机号校验（可为空）
    mobile: function mobile(rule, value, callback) {
      var regexp = /^1[3-9]\d{9}$/;

      if (value) {
        if (value.match(regexp)) {
          callback();
        } else {
          callback(new Error('请输入正确的手机号'));
        }
      } else {
        callback();
      }
    },
    // 密码校验
    passWord: function passWord(rule, value, callback) {
      // let reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#_$\%\^\.\,\&\*\(\)\?\<\>\;\'\:\"\[\]\/\{\}\|\=\+\\\`\~\-])[0-9a-zA-Z!@#_$\%\^\.\,\&\*\(\)\?\<\>\;\'\:\"\[\]\{\}\|\/\=\+\\\`\~\-]{8,20}$/;
      // let reg = /^(?=.*[0-9])(?=.*[a-zA-Z])[0-9a-zA-Z!@#_$\%\^\.\,\&\*\(\)\?\<\>\;\'\:\"\[\]\{\}\|\/\=\+\\\`\~\-]{8,20}$/;
      // if (value) {
      //   if (value.match(reg)) {
      //     callback();
      //   } else {
      //     callback(new Error('密码必须为8-20位——包含数字、字母组合'));
      //   }
      // } else {
      //   callback();
      // }
      if (value.length < 8 || value > 20) {
        callback(new Error('请将密码设置为8-20位，并且由字母，数字组合'));
      } else if (/^[0-9]*$/.test(value) || /^[a-zA-Z]+$/.test(value)) {
        callback(new Error('有被盗风险,建议使用字母、数字两种组合'));
      } else if (/^(?=.*[0-9])(?=.*[a-zA-Z])[0-9a-zA-Z]{8,20}$/.test(value)) {
        callback();
      } else {
        callback(new Error('请将密码设置为8-20位，并且由字母，数字组合'));
      }
    },
    // 密码确认校验
    validatePassCheck: function validatePassCheck(rule, value, callback) {
      if (value === '') {
        callback(new Error('确认密码不能为空！'));
      } else if (value !== data.formValue.newPassword) {
        callback(new Error('确认密码与新密码不相同！'));
      } else {
        callback();
      }
    },
    // 座机校验
    tel: function tel(rule, value, callback) {
      var reg = /^((0\d{2,3}(\-)?\d{7,8}|(0\d{2,3}(\-)?\d{7,8}(\-)?\d{3,5}))|[0-9]{8})$/;

      if (value) {
        if (value.match(reg)) {
          callback();
        } else {
          callback(new Error('请输入正确的固定电话号'));
        }
      } else {
        callback();
      }
    },
    // 校验用户名
    checkUserName: function checkUserName(rule, value, callback) {
      var reg = new RegExp('^([a-zA-Z0-9\\_]){6,20}$');

      if (!reg.test(value)) {
        callback(new Error('用户名不正确或已存在'));
      } else {
        callback();
      }
    },
    // 统一社会信用代码必填校验
    orgCertificateCode: function orgCertificateCode(rule, value, callback) {
      var reg = /^[0-9A-Z]{18}$/;

      if (!value) {
        callback(new Error('统一社会信用代码不能为空'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确统一社会信用代码'));
      } else {
        callback();
      }
    },
    // 统一社会信用代码可不用必填校验
    orgCertificateCodeNull: function orgCertificateCodeNull(rule, value, callback) {
      var reg = /^[0-9a-zA-Z]{18,20}$/;

      if (value && !reg.test(value)) {
        callback(new Error('请输入正确统一社会信用代码'));
      } else {
        callback();
      }
    },
    // 工号只能输入数字
    numberVal: function numberVal(rule, value, callback) {
      var reg = /^[0-9]*$/;

      if (!reg.test(value) && value) {
        callback(new Error('工号只能为数字!'));
      } else {
        callback();
      }
    },
    // 传真
    faxVal: function faxVal(rule, value, callback) {
      var reg = /^(?:\d{3,4}-)?\d{7,8}(?:-\d{1,6})?$/;

      if (!reg.test(value) && value) {
        callback(new Error('请输入正确的传真格式!'));
      } else {
        callback();
      }
    },
    // 身份证号码
    idNumber: function idNumber(rule, value, callback) {
      var reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;

      if (!reg.test(value) && value) {
        callback(new Error('请输入正确的身份证号码!'));
      } else {
        callback();
      }
    },
    taxpayerId: function taxpayerId(rule, value, callback) {
      var regexp = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/;

      if (value !== '') {
        if (!regexp.test(value)) {
          callback(new Error('请输入正确的纳税人识别号'));
        } else {
          callback();
        }
      } else {
        callback(new Error('纳税人识别号不能为空'));
      }
    }
  };
};

export default validator;